export function getCurrencySign(entity) {
  return (entity?.currency_code || entity?.currencyCode || 'USD').toLowerCase() === 'eur' ? '€' : '$';
}

export function getLocalePrice(entity, total = 0, round = false) {
  const s = getCurrencySign(entity);
  return `${s}${total.toLocaleString(s === '$' ? 'en-US' : 'de-DE', { minimumFractionDigits: round ? 0 : 2, maximumFractionDigits: round ? 0 : 2 })}`;
}

export default {
  getLocalePrice,
  getCurrencySign
}